import {
  FormControl,
  type FormControlProps,
  InputLabel,
  MenuItem,
} from "@mui/material";
import Select, { type SelectProps } from "@mui/material/Select";

import { Option } from "api/common/types/common.types";
import { useFieldContext } from "components/Forms/AppForm";

import ErrorMessage from "../../helpers/ErrorMessage";

import { useNormalizedOptions } from "./UseNormalizedOptions";

type SelectFieldProps = SelectProps<string> & {
  options: Option[] | string[];
  label: string;
  containerProps?: FormControlProps;
  onChange?: (_value: string) => void;
};

const SelectField = ({
  options = [],
  label,
  containerProps,
  sx,
  required = false,
  onChange,
  ...props
}: SelectFieldProps) => {
  const field = useFieldContext<string>();

  const normalizedOptions = useNormalizedOptions(options);

  return (
    <FormControl fullWidth size="small" {...containerProps} required={required}>
      <InputLabel
        id={`${label}-select-label`}
        error={field.state.meta.errors.length > 0}
      >
        {label}
      </InputLabel>
      <Select
        labelId={`${label}-select-label`}
        id={`${label}-select`}
        value={field.state.value ?? ""}
        label={label}
        onChange={(e) => {
          field.handleChange(e.target.value);
          onChange?.(e.target.value);
        }}
        sx={{
          "& .MuiSelect-select": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          },
          ...sx,
        }}
        error={field.state.meta.errors.length > 0}
        {...props}
      >
        {normalizedOptions.map((opt) => (
          <MenuItem value={opt.value} key={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
      <ErrorMessage />
    </FormControl>
  );
};
export default SelectField;
